import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash.get'
import { useFormattingContext } from '../../../FormattingProvider/FormattingContext'
import { useFirmReportData } from '../../../../../api/coreData'
import { useDenaliFilter } from '../../filters/DenaliFilterContextProvider'
import ComponentLine from '../../../../charts/echarts/ComponentLine'

const useFormatters = (valueFormat, categoryFormat) => {
  const { formatter } = useFormattingContext()

  const valueFormatter = useCallback(d => formatter(d, valueFormat), [formatter, valueFormat])
  const categoryFormatter = useCallback(d => formatter(d, categoryFormat), [formatter, categoryFormat])

  return {
    valueFormatter,
    categoryFormatter
  }
}

function DenaliComponentLine ({
  reportId,
  baseQuery,
  xAccessor,
  yAccessor,
  valueFormat,
  categoryFormat,
  ...seriesProps
}) {
  const { filter, membershipFilter } = useDenaliFilter()
  const query = useMemo(() => {
    return {
      ...baseQuery,
      membershipFilter,
      filters: {
        ...(filter || {}),
        ...(baseQuery?.filters || {})
      },
      reportId
    }
  }, [reportId, baseQuery, filter, membershipFilter])

  const { valueFormatter, categoryFormatter } = useFormatters(valueFormat, categoryFormat)
  const { data: report, isLoading } = useFirmReportData(query)
  const chartData = useMemo(() => {
    const series = (report?.data || []).map(item => [get(item, xAccessor), get(item, yAccessor)])

    return {
      series
    }
  }, [report, xAccessor, yAccessor])

  if (isLoading) return null

  return (
    <ComponentLine
      data={chartData?.series || []}
      valueFormat={valueFormatter}
      categoryFormat={categoryFormatter}
      {...seriesProps}
    />
  )
}

DenaliComponentLine.propTypes = {
  reportId: PropTypes.string,
  baseQuery: PropTypes.object,
  xAccessor: PropTypes.string,
  yAccessor: PropTypes.string,
  valueFormat: PropTypes.string,
  categoryFormat: PropTypes.string
}

DenaliComponentLine.defaultProps = {
  valueFormat: 'marketValue',
  categoryFormat: 'date',
  height: 300
}

export default DenaliComponentLine
